import { h } from 'preact';
export const Share = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }),
        h("polyline", { points: "16 6 12 2 8 6" }),
        h("line", { x1: "12", y1: "2", x2: "12", y2: "15" })));
};
//# sourceMappingURL=share.js.map